<template>
  <el-dialog
    title="Mail Entegrasyon"
    :visible="Modal"
    center
    width="30%">
    <a @click="$emit('Modal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">

      <el-form-item label="Host" prop="Host">
        <el-input v-model="Form.Host"></el-input>
      </el-form-item>
      <el-form-item label="Port" prop="Port">
        <el-input v-model="Form.Port"></el-input>
      </el-form-item>
      <el-form-item label="Username" prop="Username">
        <el-input v-model="Form.Username"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="Password">
        <el-input v-model="Form.Password"></el-input>
      </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <div class="entegre">
        <a href="https://gmail.com" target="_blank">
          <img src="https://cdn.mudu.pro/Design/gmail.png">
        </a>
      </div>
      <el-button v-if="!lo" class="float-right" type="primary" size="medium" @click="Submit()"
                 icon="el-icon-check">{{$t('eGenel.0')}}
      </el-button>
      <div class="clearfix"></div>
    </div>

  </el-dialog>
</template>

<script>
  export default {
    props: ['Modal'],
    data() {
      return {
        lo: false,
        Form: {
          Host: null,
          Port: null,
          Username: null,
          Password: null
        },
        FormHata: {
          Host: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Port: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Username: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Password: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
        },

      }
    },
    methods: {

      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'entegrasyon/mail'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Form = response.Data
            }
          });

      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {
              ...this.Form,
              path: 'entegrasyon/mail'
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                }
              })
          }
        })
      }
    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>
  .entegre {
    display: inline-block;
    float: left;
    text-align: left;
  }

  .entegre h5 {
    font-size: 10px;
  }

  button {
    margin-top: 15px;
  }

  .entegre img {
    width: 100px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/MailEntegrasyon.vue